class ListUtil {
    static addItem<T = any>(list: any[], item: any): T[] {
        const _list: T[] = list;
        _list.push(item)
        return _list;
    }

    static removeItem<T = any>(list: any[], item: any): T[] {
        const _list: T[] = list.filter((i) => i !== item);
        return _list;
    }

    static removeDuplicates(list: any[]): any[] {
        const result = [...new Set(list)];
        return result.filter((record) => record !== null);
    }

    static createRangeOfValues = (start: number, stop: number, step: number) =>
        Array.from(
          { length: Math.ceil((stop - start) / step) },
          (_, i) => start + i * step,
        );
}

export { ListUtil }